import i18next from 'i18next'
import React from 'react'
import {
  Fun,
  IOWidget,
  any,
  fromJSX,
  nothing,
  unloadedAsyncState,
} from 'widgets-for-react'
import { DataLayer } from '../../../../utils/datalayer'
import { videoUrl } from '../../../../utils/plyr'
import { blogTeasersWidget } from '../../blogs/blogTeasers/blogTeasersWidget'
import { componentTeasersWidget } from '../../components/componentTeasers/componentTeasersWidget'
import { PublicHomePageHeader } from '../../pageHeader/pageHeaderLayout'
import { PreFooterCtaLayout } from '../../paywall/paywallLayout'
import { HomeData } from '../home.state'
import { HomeCTABlockLayout } from './loggedOutHomeLayout/homeCTABlockLayout'
import { HomeQuoteCarouselBlockLayout } from './loggedOutHomeLayout/homeQuoteCarouselBlockLayout'
import { HomeTextImageBlockLayout } from './loggedOutHomeLayout/homeTextImageBlockLayout'
import {
  ExtendedLoggedOutHomeState,
  LoggedOutHomeState,
  loggedOutHomeStateUpdaters,
} from './loggedOutHomeState'

export const homeInViewThreshold = 0.15

export const loggedOutHomeWidget =
  (
    homeData?: HomeData
  ): IOWidget<
    LoggedOutHomeState,
    Fun<LoggedOutHomeState, ExtendedLoggedOutHomeState>
  > =>
  (state) =>
    any<Fun<LoggedOutHomeState, ExtendedLoggedOutHomeState>>([
      fromJSX((setState) => {
        const video = videoUrl(i18next.t('home:pageHeaderVideoURL'))
        //@ts-ignore Loading in uc (UserCentrics) as global in the browser, but TypeScript doesn't get the type definition so we ignore it.
        if(typeof window['uc'] !== 'undefined' && video.kind === 'r') {
          //@ts-ignore after accepting the consent, the video will reload properly in the modal.
          window['uc']?.reloadOnOptIn(video.v?.sources[0]?.src);
        }
        return (
          <PublicHomePageHeader
            video={video}
            videoOpened={state.videoOpened}
            openVideo={() => {
              setState(loggedOutHomeStateUpdaters.updateVideoOpened(true))
              DataLayer.headerButtonsClick(
                i18next.t('home:pageHeaderWatchVideo')
              )
            }}
            closeVideo={() =>
              setState(loggedOutHomeStateUpdaters.updateVideoOpened(false))
            }
          />
        )
      }),
      homeData == undefined
        ? nothing()
        : componentTeasersWidget(
            unloadedAsyncState(),
            'home-logged-out',
            'link-only',
            {
              title: i18next.t('home:componentsOverviewTitle'),
              intro: i18next.t('home:componentsOverviewIntro'),
            }
          )(homeData.componentTeasers).map(
            loggedOutHomeStateUpdaters.updateComponentTeasers
          ),
      fromJSX((setState) => (
        <>
          <HomeTextImageBlockLayout />
          <HomeCTABlockLayout />
          <HomeQuoteCarouselBlockLayout
            slides={state.quoteCarouselData}
            setSlides={(data) =>
              setState(loggedOutHomeStateUpdaters.updateQuoteCarouselData(data))
            }
          />
        </>
      )),
      homeData == undefined
        ? nothing()
        : blogTeasersWidget(
            'home-logged-out',
            i18next.t('home:blogsTitle')
          )(homeData.blogTeasers).map(
            loggedOutHomeStateUpdaters.updateBlogTeasersDataState
          ),
      fromJSX(() => <PreFooterCtaLayout.Register />),
    ])
